import React, { useState } from "react";
import KuikaSwitch from "../../../../ui-kit/kuika-switch/kuika-switch";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";
import { noop } from "../_layout/utils";
import { VariantGrid } from "../_layout/variant-grid";

interface IStatefulProps {
  initial?: boolean;
  label?: string;
  disabled?: boolean;
  labelPosition?: "right" | "left" | "none";
  align?: "center" | "top";
}

const Stateful: React.FC<IStatefulProps> = ({ initial = false, ...rest }) => {
  const [checked, setChecked] = useState<boolean>(initial);
  return <KuikaSwitch checked={checked} onChange={(c: boolean) => setChecked(c)} {...rest} />;
};

export const SwitchStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Switch"
      componentName="KuikaSwitch"
      sourcePath="ui-kit/kuika-switch"
      description="On/off toggle. The thumb springs across and, held down, stretches toward where it is going; a disabled switch shakes when pressed. Focus ring on keyboard focus; 32px hit area."
    >
      <VariantGrid
        label="state · checked"
        rows={["enabled", "disabled"]}
        cols={["off", "on"]}
        render={(state: string, on: string): React.ReactNode => (
          <KuikaSwitch checked={on === "on"} disabled={state === "disabled"} onChange={noop} />
        )}
      />
      <SpecRow label="Motion" caption="hold the pointer down to see the stretch · press the disabled one">
        <Stateful label="Spring and stretch" />
        <Stateful initial label="Disabled — shakes when pressed" disabled />
      </SpecRow>
      <SpecRow label="Label position">
        <Stateful initial label="Right (default)" labelPosition="right" />
        <Stateful initial label="Left" labelPosition="left" />
        <Stateful initial labelPosition="none" />
      </SpecRow>
    </ShowcaseFrame>
  );
};
